import { render } from "./LoadingAnimation.vue?vue&type=template&id=4137719c&scoped=true"
const script = {}

import "./LoadingAnimation.vue?vue&type=style&index=0&id=4137719c&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4137719c"]])

export default __exports__